<template>
    <div class="container">
        <div class="title">为本次服务打分</div>
        <van-field>
            <template #input>
                <van-rate
                    v-model="formObject.point"
                    allow-half
                    void-icon="star"
                    color="var(--yellow)"
                    void-color="var(--bg)"
                />
            </template>
        </van-field>
        <div class="title">评价本次咨询服务的体验</div>
        <van-field
            v-model="formObject.content"
            rows="4"
            autosize
            type="textarea"
            maxlength="255"
            placeholder="如:热情情切，十分敬业"
            show-word-limit
        />

        <div class="tools">
            <van-button
                round
                block
                size="small"
                type="primary"
                native-type="button"
                :loading="loading"
                @click="submitHandle"
            >
                提交
            </van-button>
        </div>
    </div>
</template>

<script>
import manageApi from '@/api/manageApi';

export default {
    data() {
        return {
            formObject: {
                point: 5,
                content: ''
            },
            loading: false
        };
    },
    methods: {
        submitHandle() {
            const { formObject, $toast, medicalRecordId, $router } = this;
            if (0 === _.size(formObject.content)) {
                $toast('请评价本次咨询服务的体验');
                return;
            }
            this.loading = true;
            manageApi.submitMedicalEvaluation({
                medicalRecordId: medicalRecordId,
                ...formObject
            }).then(res => {
                $toast('评价成功');
                $router.go(-1);
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    props: {
        medicalRecordId: {
            type: String,
            required: true
        }
    }
}
</script>


<style lang="less" scoped>
.container {
    min-height: 100vh;
    background-color: @white-color;

    .title {
        font-size: 0.426667rem;
        padding: 0.266667rem 0.42667rem 0 0.42667rem;
    }

    /deep/textarea.van-field__control {
        border: 1px solid @bg-color;
        border-radius: 0.1rem;
        padding: 0.2rem;
        background-color: @border-color;
    }

    .tools {
        position: fixed;
        bottom: 0;
        background-color: @white-color;
        padding: 0.213333rem 0.48rem;
        left: 0;
        right: 0;
        height: 0.933333rem;
        box-shadow: 0 -0.06rem 0.1rem 0.04rem rgba(0, 0, 0, 0.03);
        display: flex;
        align-items: center;
    }
}
</style>